<template>
  <div class="w-full h-full relative">
    <O3D v-if="renderer" class="">
      <Game :mode="'church'" :char="'girl'"></Game>

      <!-- <SwatWalk></SwatWalk> -->

      <!-- <O3D layout="flower">
        <Flower></Flower>
      </O3D> -->

      <O3D layout="holyplace">
        <O3D layout="holyCross">
          <HolyCross></HolyCross>
        </O3D>

        <O3D layout="church">
          <Church></Church>
        </O3D>

        <!--
        <O3D layout="diamonds">
          <Diamonds></Diamonds>
        </O3D> -->

      </O3D>
      <!-- <DebguBox></DebguBox> -->
    </O3D>
  </div>
</template>

<script>
import { RenderRoot } from '../Reusable/RenderRoot'
import { PCamera } from '../Reusable/PCamera'
import { Scene } from 'three'
export default {
  mixins: [RenderRoot],
  components: {
  },
  data () {
    return {
      layouts: {
      },
      renderer: false,
      camera: false,
      scene: new Scene()
    }
  },
  methods: {
    setup () {
      this.camera = new PCamera({ element: this.renderRootElement, onResize: this.onResize })
      this.scene.add(this.o3d)
      // this.scene.background = new Color('#ffffff')
    }
  },
  mounted () {
    this.setup()

    this.onLoop(() => {
      this.layouts.holyCross = {
        pz: -450 - 1300,
        py: 20,
        sx: 7,
        sy: 7,
        sz: 7
      }
      this.layouts.church = {
        pz: 0,
        py: 5
      }
      this.layouts.holyplace = {
        pz: 500
      }
    })

    this.renderRootElement.style.backgroundImage = `url('${require('./img/stained-glass.jpg')}')`
    // this.renderRootElement.style.backgroundImage = `url('${require('./img/skyspace.jpg')}')`
    this.renderRootElement.style.backgroundSize = `cover`
    this.renderRootElement.style.backgroundColor = `black`
    this.renderRootElement.style.backgroundPosition = `center center`
    this.renderRootElement.style.backgroundRepeat = `no-repeat no-repeat`
  },
  beforeDestroy () {
    this.renderRootElement.style.backgroundSize = ``
    this.renderRootElement.style.backgroundImage = ``
    this.renderRootElement.style.backgroundColor = ``
    this.renderRootElement.style.backgroundPosition = ``
    this.renderRootElement.style.backgroundRepeat = ``
  }
}
</script>

<style>
</style>
